export const INFURA_TOKEN = process.env.REACT_APP_INFURA_TOKEN
